var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1453 7.97266C24.6785 8.46484 24.6785 9.32617 24.1453 9.81836L13.6453 20.3184C13.1531 20.8516 12.2918 20.8516 11.7996 20.3184L6.54956 15.0684C6.01636 14.5762 6.01636 13.7148 6.54956 13.2227C7.04175 12.6895 7.90308 12.6895 8.39527 13.2227L12.7019 17.5293L22.2996 7.97266C22.7918 7.43945 23.6531 7.43945 24.1453 7.97266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.911fe9f79e0bf8988d490ef5638bf3d0.svg";
export { ForwardRef as ReactComponent };